export const TOKEN = "token";
export const USER_ID = "userId";
export const USER_TYPE = "userType";
export const LOCALE = "locale";
export const VOUCH_CODE = "vouchCode";
export const APP_DOWNLOAD = "appDownload";
export const DAILY_BRIEF_HIDDEN = "dailyBriefHidden";
